module.exports = __webpack_public_path__ + "static/img/confirm2.119f57d8.png";